import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';

//import components
import PaginationTotal from './PaginationTotal.js';
import PaginationNext from './PaginationNext.js';
import PaginationPrevious from './PaginationPrevious.js';

const PaginationList = ({clang, totalPages, currentPage, setNextPage, setPreviousPage, setPageByNum}) => {
    const filteredNumbers = [...Array(totalPages + 1).keys()].filter(num =>
                                num > 0 && num <= totalPages &&
                                ((num >= currentPage - 1 && num <= currentPage + 1) || num === totalPages || num === 1 ));

    const displayedPagesWithDots = () => {
        filteredNumbers.forEach(function(number, index) {
            if (number + 1 !== filteredNumbers[index+1] && filteredNumbers[index+1] && typeof number === 'number') {
                filteredNumbers.splice(index+1, 0, '...');
            }
        });

        return filteredNumbers.map((page, index) =>
                typeof page === 'number' ?
                    <li className="pagination__list-item" key={index}>
                        <button onClick={() => setPageByNum(page)}
                                className={`pagination__button ${currentPage === page ? 'active' : ''}`}>
                            {page}
                        </button>
                    </li>
                :   <li className="pagination__list-item" key={index}>
                        <span className="pagination__list-item__separator">{page}</span>
                    </li>);
    };

    return (
        <div className="pagination-list">
            {currentPage > 1 && currentPage <= totalPages && totalPages !== 1 &&
                <PaginationPrevious setPreviousPage={setPreviousPage}/>}
            <div className="pagination__pages">
                <ul className="pagination__list">
                    {displayedPagesWithDots()}
                </ul>
                <PaginationTotal
                    totalPages={totalPages}
                    currentPage={currentPage}
                    setPageByNum={setPageByNum}/>
            </div>
            {currentPage >= 1 && currentPage < totalPages &&
                <PaginationNext setNextPage={setNextPage}/>}
        </div>
    );
};

PaginationList.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(PaginationList);



// WEBPACK FOOTER //
// ./src/components/pagination/PaginationList.js